import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Custom directive to intercept the primeng password input component's eye toggle.
 * If the eye icon is clicked, we send an event back to toggle the price input masks.
 */
@Directive({ selector: '[pzPasswordEye]' })
export class PasswordEyeDirective {
  @Output()
  private togglePriceMask = new EventEmitter();

  @HostListener('click', ['$event.target'])
  public onClick(element: HTMLElement): void {
    // eye icon (<i>) was clicked
    if (element.tagName === 'I') {
      this.togglePriceMask.emit();
    }
  }
}
